import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import InViewObserverForSideMenu from "../functions/in-view-observer-for-side-menu"

export default function BeAGoodNeighbor() {
  const [isHover, setIsHover] = useState(false)
  useEffect(() => {
    let seminarBtn = document.getElementById("seminarBtn")
    let seminarSubtitle = document.getElementById("seminarSubtitle")
    if(isHover) {
      seminarBtn.style.cssText = "background: #fff; color: #444; border: solid 6px #444; filter: none;"
      seminarSubtitle.style.cssText = "color: #666666;"
    } else {
      seminarBtn.style.cssText = "background: #199F4D; border: solid 6px #199F4D"
      seminarSubtitle.style.cssText = "color: #fff;"
    }
  }, [isHover])

  return (
    <>
    <div className="contents be_a_good_neighborArea scroll-point" id="contact">
      <InViewObserverForSideMenu targetLiId={"contactLi"} />
      <div className="contents_in">
        <div className="padding_sp">{/* スマホのみ隙間 */}
          {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
          <div className="neighbor_title">
            <div className="title_in">
              <p className="subtitle"><span>まずは、お近づきになりましょう！</span></p>
              <h3 className="maintitle"><span>Be a good neighbor</span></h3>
            </div>{/* catch_in */}
          </div>{/* /catch1 */}
          {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
          <div className="neighbor_wrap">
            <ul className="neighbor_box">
              <li className="neighbor_ttl newsletter_btn"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              >
                  <Link to="/newsletter">Newsletter<span className="subttl">ジェイフィールの最新情報</span></Link>
              </li>
              <li className="neighbor_ttl seminar_btn">
                <Link to="/seminar" id={"seminarBtn"}>Seminar<span className="subttl" id={"seminarSubtitle"}>知りたい・話したい・考えたい</span></Link>
              </li>
              <li className="neighbor_ttl contact_btn"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              >
                <Link to="https://ma.j-feel.jp/inquiry.html">Contact<span className="subttl">自由なお問い合わせ</span></Link>
              </li>
            </ul>
          </div>
        </div>{/* padding_sp スマホのみ隙間 */}
      </div>{/* contents_in */}
    </div>{/* /contents */}
    </>
  )
}
